import { storeToRefs } from 'pinia'
import { SessionStore } from '~/stores/session'
import { InsuranceNeedsVisibilityGateStore } from '~/stores/insuranceNeedsVisibilityGate'

export default class GhostCard {
  static use() {
    const { quotingConfig } = QuotingConfig.use()
    const session = SessionStore.use()
    const { hasDrugsOrDocsApplied } = storeToRefs(InsuranceNeedsVisibilityGateStore.use())

    const isGhostCardActive = computed(
      () =>
        quotingConfig.value.ghostCard && !session.ghostCardOptOut && !hasDrugsOrDocsApplied.value
    )

    return {
      isGhostCardActive
    }
  }
}
